import { render } from "./GameNotFound.vue?vue&type=template&id=7e466075"
import script from "./GameNotFound.vue?vue&type=script&lang=js"
export * from "./GameNotFound.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__